<template>
    <div>
        <v-radio-group v-model="product_id">
            <div id="wrapHardware">
            <h3>Hardware</h3>
        <v-divider></v-divider>

            <v-row>
                <v-col cols="lg-4" v-for="(item,i) in hardwareItems" :key="i"  class="text-center">
                    <label>
                        <v-img class="mb-1  rounded-lg" :src="item.image" max-height="200" max-width="200"/>
                        {{item.name}}
                        <v-radio :value="item.product_id" class="mr-auto ml-auto">
                        </v-radio>
                    </label>
                </v-col>
            </v-row>
                <br><v-divider></v-divider></div>
        <div id="wrapUpgrade"><h3>Upgrade</h3>
          <h4>Which programmer are you upgrading? </h4>
            <v-divider></v-divider><br>
            <v-row>
                <v-col cols="lg-4" v-for="(item,i) in UpgradeItems" :key="i"  class="text-center">
                    <label>
                        <v-img class="mb-1 rounded-lg" :src="item.image" max-height="150" max-width="150"/>
                        {{item.name}}
                        <v-radio :value="item.product_id" class="mr-auto ml-auto">
                        </v-radio>
                    </label>
                </v-col>
            </v-row><br><v-divider></v-divider><br></div>
        </v-radio-group>
         <v-btn
                class="firstContinueBtn"
                color="primary"
                @click="setStep2"
        >
            Continue
        </v-btn>
     </div>
</template>

<script>
    export default {
        name: "ProductsList",
        props: ['setStep2','setPrecartProduct', 'items', 'product_id', 'setProductID', 'is_user_logged_in'],
        watch: {
            product_id() {


                if (this.product_id) {
                    this.productSelected()
                }
            }
        },
        computed: {
            // returns list of cars based of filters
            hardwareItems() {
                let vm = this.items;

                return vm.filter(car => {
                    return car.category == 'Hardware'
                })
            },
            UpgradeItems() {
                let vm = this.items;

                return vm.filter(car => {
                    return car.category == 'Upgrade'
                })
            }

        }, methods: {
            productSelected() {
                this.setProductID(this.product_id)
            }
        },
    }
</script>

<style scoped>
    .login_overlay {
        display: none;
    }

    #app h2 {
        font-size: 38px;
        font-weight: 100;
    }

    #app h3 {
        padding-top: 65px;
        font-size: 35px;
    }
</style>